<template>
  <div class="dash-card requests-alerts-widget">
    <div class="dash-card-header">
      <h3 class="dash-card-title">
        <span
          class="dash-card-title-icon"
          style="background: #fff7e6; color: #fa8c16"
        >
          <a-icon type="exclamation-circle" />
        </span>
        {{ $t("accueil.dashboard.pendingRequests") }}
      </h3>
    </div>

    <div class="dash-card-body">
      <div class="requests-grid">
        <div
          v-for="req in requestsList"
          :key="req.key"
          class="request-tile"
        >
          <span
            class="request-icon"
            :style="{ color: req.color, backgroundColor: req.color + '18' }"
          >
            <a-icon :type="req.icon" />
          </span>
          <span class="request-count">{{ req.count }}</span>
          <span class="request-label">{{ req.label }}</span>
          <span class="request-status dash-badge dash-badge-warning">
            {{ $t("accueil.dashboard.enAttenteReponse") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RequestsAlertsWidget",
  props: {
    requests: {
      type: Object,
      default: () => ({
        parents: 0,
        eleves: 0,
        personnel: 0,
      }),
    },
  },
  computed: {
    requestsList() {
      const a = this.requests || {};
      return [
        {
          key: "parents",
          icon: "usergroup-add",
          color: "#1890ff",
          label: this.$t("accueil.dashboard.requestsParents"),
          count: a.parents || 0,
        },
        {
          key: "eleves",
          icon: "user",
          color: "#52c41a",
          label: this.$t("accueil.dashboard.requestsEleves"),
          count: a.eleves || 0,
        },
        {
          key: "personnel",
          icon: "idcard",
          color: "#722ed1",
          label: this.$t("accueil.dashboard.requestsPersonnel"),
          count: a.personnel || 0,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.requests-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.request-tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px;
  text-align: left;
  border-radius: var(--dash-radius, 16px);
  border: 1px solid var(--dash-border, #e8ecf1);
  background: var(--dash-bg, #fff);
  box-shadow: none;
}

.request-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 4px;
}

.request-count {
  font-size: 1.6rem;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1;
}

.request-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #595959;
}

.request-status {
  margin-top: 2px;
}

[data-kit-theme="dark"] {
  .request-count {
    color: #aeaee0;
  }

  .request-label {
    color: #7575a3;
  }
}
</style>
